import { baseURL } from '..';
import { IGeometry, IProject } from '../../shared/iProject';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';
import { IGetGeometryPreviewResponse } from './iApiResponse';

const GeometryProvider = () => {

    const getGeometryPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string, withTests?: boolean): Promise<IResponse<IPaginatedResponse<IGetGeometryPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Geometry/GetGeometryPreviews', paginationQuery(pageNumber, pageSize, filter, withTests)), createHeaders());

    const getGeometryByIdAsync = async (id: number): Promise<IResponse<IGeometry>> => httpClient.getAsync(createRequest(baseURL, '/Geometry/GetGeometry', `?id=${id}`), createHeaders());

    const updateGeometryAsync = async (payload: IGeometry): Promise<IResponse<IGeometry>> =>
        httpClient.putAsync(createRequest(baseURL, '/Geometry/UpdateGeometry', undefined, payload), createHeaders());

    const getAllGeometryPreviewAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IGetGeometryPreviewResponse>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Geometry/GetAllGeometryPreviews', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const updateGeometryWithMaterialsAsync = async (payload: FormData): Promise<IResponse<IProject>> =>
        httpClient.putAsync(createRequest(baseURL, '/Geometry/UpdateGeometryWithMaterials', undefined, payload), createHeaders('multipart/form-data'));

    const InsertGeometryAsync = async (payload: FormData): Promise<IResponse<IProject>> =>
        httpClient.postAsync(createRequest(baseURL, '/Geometry/InsertGeometry', undefined, payload), createHeaders('multipart/form-data'));

    return { getGeometryPreviewAsync, getAllGeometryPreviewAsync, getGeometryByIdAsync, updateGeometryAsync, updateGeometryWithMaterialsAsync, InsertGeometryAsync };
};

export default GeometryProvider();
